export enum Sections {
    Account = 'Account',
    Entry = 'New Entry',
    Navigation = 'Navigation'
}